var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11C18.0523 11 18.5 10.5523 18.5 10C18.5 9.44772 18.0523 9 17.5 9V11ZM3.5 10L2.79289 9.29289C2.5069 9.57889 2.42134 10.009 2.57612 10.3827C2.7309 10.7564 3.09554 11 3.5 11V10ZM8.20711 6.70711C8.59763 6.31658 8.59763 5.68342 8.20711 5.29289C7.81658 4.90237 7.18342 4.90237 6.79289 5.29289L8.20711 6.70711ZM7.5 13C6.94772 13 6.5 13.4477 6.5 14C6.5 14.5523 6.94772 15 7.5 15V13ZM21.5 14L22.2071 14.7071C22.4931 14.4211 22.5787 13.991 22.4239 13.6173C22.2691 13.2436 21.9045 13 21.5 13V14ZM16.7929 17.2929C16.4024 17.6834 16.4024 18.3166 16.7929 18.7071C17.1834 19.0976 17.8166 19.0976 18.2071 18.7071L16.7929 17.2929ZM17.5 9H3.5V11H17.5V9ZM4.20711 10.7071L8.20711 6.70711L6.79289 5.29289L2.79289 9.29289L4.20711 10.7071ZM7.5 15L21.5 15V13L7.5 13V15ZM20.7929 13.2929L16.7929 17.2929L18.2071 18.7071L22.2071 14.7071L20.7929 13.2929Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.81a56755adea738b5bccfd21573c6d8f.svg";
export { ForwardRef as ReactComponent };